import djangoPermissions from './_permissions'

const djangoApps = Object.keys(djangoPermissions)

export default djangoApps
